<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>

<div *ngIf="!isEdit" class="container">
  <h1 class="text-center lifedi-color">
    สร้างวิจัย
  </h1>
  <form [formGroup]="researchForm">
    <div class="form-group row">
      <label for="name" class="col-2 col-form-label">ชื่อวิจัย<lifedi-require></lifedi-require></label>
      <div class="col-10">
        <input type="text" class="form-control" id="name" formControlName="name" autocomplete="off">
      </div>
    </div>
    <div class="form-group row">
      <label for="consent" class="col-2 col-form-label">ข้อความยินยอม<lifedi-require></lifedi-require></label>
      <div class="col-10">
        <angular-editor id="_content" formControlName="consent" placeholder="ใส่ข้อความยินยอม" style="margin: 0 auto;"
          [config]="editorConfigConsent">
        </angular-editor>
      </div>
    </div>
    <div class="form-group row">
      <label for="detail" class="col-2 col-form-label">รายละเอียดวิจัย<lifedi-require></lifedi-require></label>
      <div class="col-10">
        <angular-editor id="_content" formControlName="detail" placeholder="ใส่รายละเอียดวิจัย" style="margin: 0 auto;"
          [config]="editorConfig">
        </angular-editor>
      </div>
    </div>
    <div class="form-group row">
      <label for="date" class="col-2 col-form-label">ระยะเวลาเข้าร่วม<lifedi-require></lifedi-require></label>
      <div class="col-6">
        <input [attr.disabled]="researchForm.value.alwaysOpen ? true : null" id="date" class="form-control"
          date-format="dd-MM-yyyy HH:mm:ss" formControlName="date" [selectMode]="'range'"
          [owlDateTimeTrigger]="dtPicker" [owlDateTime]="dtPicker" [rangeSeparator]="'-'" dateFormat="dd-MM-yyyy"
          autocomplete="off">
        <owl-date-time [pickerType]="'calendar'" #dtPicker></owl-date-time>
      </div>
      <div class="col-2 justify-content-center align-self-center col-form-label">
        <section>
          <mat-checkbox id="alwaysOpen" color="primary" formControlName="alwaysOpen"
            (click)="clearValueResearchDate(researchForm)" [(ngModel)]="researchForm.value.alwaysOpen">
            เปิดตลอด
          </mat-checkbox>
        </section>
      </div>
    </div>
    <div class="form-group row">
      <label for="researchImg" class="col-2 col-form-label">รูปปก</label>
      <div class="col-6">
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="researchImg" accept=".png, .jpg, .jpeg"
            (change)="onCoverSelected($event, researchForm)">
          <label *ngIf="!researchImg" class="custom-file-label" for="researchImg">Choose file</label>
          <label *ngIf="researchImg" class="custom-file-label" for="researchImg">{{ researchImg }}</label>
        </div>
      </div>
      <button *ngIf="researchImg" mat-icon-button style="display: inline;" (click)="deleteResearchImg(researchForm)">
        <span class="text-danger">✖</span>
      </button>
    </div>
    <div class="form-group row">
      <label for="researchDocument" class="col-2 col-form-label">เอกสารประกอบงานวิจัย</label>
      <div class="col-6">
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="researchDocument"
            accept=".pdf, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excelapplication/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            (change)="onDocumentSelected($event, researchForm)">
          <label *ngIf="!researchDocument" class="custom-file-label" for="researchDocument">Choose file</label>
          <label *ngIf="researchDocument" class="custom-file-label" for="researchDocument">
            {{ researchDocument}}
          </label>
        </div>
      </div>
      <button *ngIf="researchDocument" mat-icon-button style="display: inline;"
        (click)="deleteResearchDocument(researchForm)">
        <span class="text-danger">✖</span>
      </button>
    </div>
    <div class="form-group row">
      <label for="coin" class="col-2 col-form-label">Token<lifedi-require></lifedi-require></label>
      <div class="col-3">
        <input type="number" class="form-control" formControlName="coin" min="0" id="coin"
          (keyup)="checkMoreThanZero($event)">
      </div>
    </div>
    <div class="form-group row">
      <label for="coin" class="col-2 col-form-label">Token สำหรับคนแชร์<lifedi-require></lifedi-require><br>
        <small class="text-danger">* ผู้แชร์จะได้ token เมื่อผู้เข้าลิงก์ทำวิจัยเสร็จ</small>
      </label>
      <div class="col-3">
        <input type="number" class="form-control" formControlName="coinShare" min="0" id="coin"
          (keyup)="checkMoreThanZero($event)">
      </div>
    </div>



    <div class="row mt-4">
      <div class="col-6">
        <h4>แบบสอบถามกลุ่มเป้าหมาย</h4>
        <div *ngFor="let target of targetArray.controls; let i = index;" formArrayName="target">
          <div [formGroupName]="i" class="researhCard mb-3">
            <div class="col-12">
              <div class="row" style="justify-content: right;">
                <button mat-icon-button>
                  <img src="../../../../assets/close.png" style="width: 25px;" (click)="deleteQuestion(i)">
                </button>
              </div>
              <div class="container">
                <div class="row mb-3">
                  <label class="col-3 col-form-label">ประเภทคำถาม<lifedi-require></lifedi-require></label>
                  <div class="col-9">
                    <select class="custom-select form-control" formControlName="type" style="display: inline;"
                      (change)="clearForm(target, 'target')">
                      <option selected disabled hidden>เลือกประเภท</option>
                      <option value="choices">Mulitple Choices</option>
                      <option value="text">Text</option>
                      <option value="checkbox">Checkbox</option>
                    </select>
                  </div>
                </div>

                <div *ngIf="target.value.type.length > 0">
                  <div *ngIf="target?.value.type === 'choices'">
                    <div class="row mb-3">
                      <label class="col-3 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
                      <div class="col-9">
                        <input type="text" class="form-control" id="question" formControlName="question"
                          autocomplete="off" ngDefaultControl>
                      </div>
                    </div>
                    <div *ngFor="let c of target.get('choices')['controls']; let j = index" formArrayName="choices">
                      <div [formGroupName]="j" class="row mb-2">
                        <label class="col-2 col-form-label">C{{ j+1 }}<lifedi-require></lifedi-require></label>
                        <input class="form-control col-9" formControlName="choices_detail" type="text">
                        <button *ngIf="j >= 1" mat-mini-fab class="img col-1"
                          (click)="deleteChoice(target.get('choices'), j)"
                          [style.backgroundImage]="'url(\'../../../../assets/remove.png\')'">
                        </button>
                      </div>
                    </div>
                    <!-- <pre>
                      {{target.value | json}}
                    </pre> -->
                    <button mat-mini-fab class="img col-1 mb-2" (click)="addChoice(target.get('choices'))"
                      [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
                    </button>
                  </div>


                  <div *ngIf="target.value.type === 'text'">
                    <div class="row mb-3">
                      <label class="col-3 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
                      <div class="col-9">
                        <input type="text" class="form-control" id="question" formControlName="question"
                          autocomplete="off" ngDefaultControl>
                      </div>
                    </div>
                    <!-- <pre>
                      {{target.value | json}}
                    </pre> -->
                  </div>

                  <div *ngIf="target.value.type === 'checkbox'">
                    <div class="row mb-3">
                      <label class="col-3 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
                      <div class="col-9">
                        <input type="text" class="form-control" id="question" formControlName="question"
                          autocomplete="off" ngDefaultControl>
                      </div>
                    </div>
                    <div *ngFor="let c of target.get('choices')['controls']; let j = index" formArrayName="choices">
                      <div [formGroupName]="j" class="row mb-2">
                        <label class="col-2 col-form-label">C{{ j+1 }}<lifedi-require></lifedi-require></label>
                        <input class="form-control col-9" formControlName="choices_detail" type="text">
                        <button *ngIf="j >= 1" mat-mini-fab class="img col-1"
                          (click)="deleteChoice(target.get('choices'), j)"
                          [style.backgroundImage]="'url(\'../../../../assets/remove.png\')'">
                        </button>
                      </div>
                    </div>
                    <!-- <pre>
                      {{target.value | json}}
                    </pre> -->
                    <button mat-mini-fab class="img col-1 mb-2" (click)="addChoice(target.get('choices'))"
                      [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <lifedi-btn lable="เพิ่มคำถามกลุ่มเป้าหมาย" class="mt-3 mb-3"
            customStyle="padding: 0 25px; background: #414A6B; color:#FFFFFF" (click)="addTarget()">
          </lifedi-btn>
        </div>
      </div>


      <div class="col-6">
        <h4>แบบทดสอบที่ใช้ในวิจัย</h4>
        <div *ngFor="let measure of measureArray.controls; let i = index;" formArrayName="measures">
          <div [formGroupName]="i" class="researhCard mb-3">
            <div class="col-12">
              <div class="row" style="justify-content: right;">
                <button mat-icon-button>
                  <img src="../../../../assets/close.png" style="width: 25px;" (click)="deleteMeasure(i)">
                </button>
              </div>
              <div class="container">
                <div class="row mb-3">
                  <label class="col-3 col-form-label">Wave {{ i+1 }}<lifedi-require></lifedi-require></label>
                  <div class="col-9">
                    <select *ngIf="i === 0" class="custom-select form-control" formControlName="type"
                      style="display: inline;" (change)="clearForm(measure, 'measures')">
                      <option selected disabled hidden>เลือกประเภท</option>
                      <option value="time">ช่วงเวลา</option>
                      <option value="age">ช่วงอายุ</option>
                    </select>
                    <select *ngIf="i > 0" class="custom-select form-control" formControlName="type"
                      style="display: inline;" disabled>
                      <option selected disabled hidden>เลือกประเภท</option>
                      <option value="time">ช่วงเวลา</option>
                      <option value="age">ช่วงอายุ</option>
                    </select>
                  </div>
                </div>

                <div *ngIf="measure.value.type === 'time'">
                  <div class="row mb-3">
                    <label class="col-3 col-form-label">ช่วงเวลา<lifedi-require></lifedi-require></label>
                    <div class="col-9">
                      <input id="moment" class="form-control" date-format="dd-MM-yyyy HH:mm:ss" formControlName="moment"
                        [selectMode]="'range'" [owlDateTimeTrigger]="dtPicker" [owlDateTime]="dtPicker"
                        [rangeSeparator]="'-'" dateFormat="dd-MM-yyyy" autocomplete="off"
                        (dateTimeChange)="setDate($event, measure)">
                      <owl-date-time [pickerType]="'calendar'" #dtPicker></owl-date-time>
                    </div>
                  </div>
                  <div *ngFor="let m of measure.get('measures')['controls']; let j = index" formArrayName="measures">
                    <div [formGroupName]="j" class="row mb-2">
                      <label class="col-3 col-form-label">แบบทดสอบ {{ j+1 }}<lifedi-require></lifedi-require></label>
                      <select class="custom-select form-control col-8" formControlName="measure_id"
                        (change)="setMeasure(measure.get('measures'), j, m)">
                        <option *ngFor="let item of allActiveMeasure" [ngValue]="item.MEASURE_ID">
                          {{item.MEASURE_NAME}}
                        </option>
                      </select>
                      <button *ngIf="j >= 1" mat-mini-fab class="img col-1"
                        (click)="deleteSubMeasure(measure.get('measures'), j)"
                        [style.backgroundImage]="'url(\'../../../../assets/remove.png\')'">
                      </button>
                    </div>
                  </div>
                  <button mat-mini-fab class="img col-1 mb-2" (click)="addSubMeasure(measure.get('measures'))"
                    [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
                  </button>
                </div>


                <div *ngIf="measure.value.type === 'age'">
                  <div class="row mb-2">
                    <label class="col-3 col-form-label">ช่วงอายุ<lifedi-require></lifedi-require></label>
                    <input type="number" class="form-control col-3" formControlName="start_year" max="100" min="1"
                      autocomplete="off" (keyup)="checkYear($event, measure, 'start_year')" (change)="setAge(measure)"
                      ngDefaultControl>
                    <label class="col-1 col-form-label">ปี</label>
                    <input type="number" class="form-control col-3" formControlName="start_month" max="11" min="0"
                      autocomplete="off" (keyup)="checkMonth($event, measure, 'start_month')" (change)="setAge(measure)"
                      ngDefaultControl>
                    <label class="col-1 col-form-label">เดือน</label>
                  </div>

                  <div class="row mb-2">
                    <label class="col-3 col-form-label">ถึงอายุ<lifedi-require></lifedi-require></label>
                    <input type="number" class="form-control col-3" formControlName="end_year" max="100" min="1"
                      autocomplete="off" (keyup)="checkYear($event, measure, 'end_year')" (change)="setAge(measure)"
                      ngDefaultControl>
                    <label class="col-1 col-form-label">ปี</label>
                    <input type="number" class="form-control col-3" formControlName="end_month" max="11" min="0"
                      autocomplete="off" (keyup)="checkMonth($event, measure, 'end_month')" (change)="setAge(measure)"
                      ngDefaultControl>
                    <label class="col-1 col-form-label">เดือน</label>
                  </div>
                  <div class="row mb-2">
                    <small *ngIf="measure.value.from_age >= measure.value.to_age" class="text-danger offset-3">
                      * ถึงอายุต้องมากกว่าช่วงอายุ
                    </small>
                  </div>

                  <div *ngFor="let m of measure.get('measures')['controls']; let j = index" formArrayName="measures">
                    <div [formGroupName]="j" class="row mb-2">
                      <label class="col-3 col-form-label">แบบทดสอบ {{ j+1 }}<lifedi-require></lifedi-require></label>
                      <select class="custom-select form-control col-8" formControlName="measure_id"
                        (change)="setMeasure(measure.get('measures'), j, m)">
                        <option *ngFor="let item of allActiveMeasure" [ngValue]="item.MEASURE_ID">
                          {{item.MEASURE_NAME}}
                        </option>
                      </select>
                      <button *ngIf="j >= 1" mat-mini-fab class="img col-1"
                        (click)="deleteSubMeasure(measure.get('measures'), j)"
                        [style.backgroundImage]="'url(\'../../../../assets/remove.png\')'">
                      </button>
                    </div>
                  </div>
                  <button mat-mini-fab class="img col-1 mb-2" (click)="addSubMeasure(measure.get('measures'))"
                    [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <lifedi-btn *ngIf="measureArray.length === 0 " lable="เพิ่ม Wave" class="mt-3 mb-3"
            customStyle="padding: 0 25px; background: #414A6B; color:#FFFFFF;" (click)="addMeasures()">
          </lifedi-btn>
          <lifedi-btn *ngIf="measureArray.length > 0 && isHaveMeasureType()" lable="เพิ่ม Wave" class="mt-3 mb-3"
            customStyle="padding: 0 25px; background: #414A6B; color:#FFFFFF;" (click)="addMeasures()">
          </lifedi-btn>
          <lifedi-btn *ngIf="measureArray.length > 0 && !isHaveMeasureType()" lable="เพิ่ม Wave" class="mt-3 mb-3"
            customStyle="padding: 0 25px;  color:#FFFFFF;" disabled="true">
          </lifedi-btn>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <lifedi-btn
        *ngIf="researchForm.valid && researchForm.value.target.length >= 1 && researchForm.value.measures.length >= 1"
        lable="สร้าง" class="mx-2 my-3" customStyle="padding: 0 25px; background: #005C3D; color:#FFFFFF"
        (click)="createResearch(researchForm.value)">
      </lifedi-btn>
      <lifedi-btn
        *ngIf="!researchForm.valid || researchForm.value.target.length === 0 || researchForm.value.measures.length === 0"
        lable="สร้าง" class="mx-2 my-3" customStyle="padding: 0 25px; color:#FFFFFF" disabled="true">
      </lifedi-btn>
    </div>

  </form>
</div>



<div *ngIf="isEdit" class="container">
  <div *ngIf="isViewOnly" class="row my-3">
    <div class="col-12 d-flex" style="justify-content: right;">
      <button class="btn btn-primary text-center mr-3" style="width: 45px;" (click)="edit()">
        <img src="assets/edit-w.png" style="width: 20px;" alt="">
      </button>
      <button class="btn btn-danger pt-1 py-2" style="width: 45px;" (click)="deleteResearch()">
        <img src="assets/delete(white).png" style="width: 20px;" alt="">
      </button>
    </div>
  </div>

  <h1 *ngIf="isViewOnly" class="text-center lifedi-color">รายละเอียดวิจัย</h1>
  <h1 *ngIf="!isViewOnly" class="text-center lifedi-color">แก้ไขวิจัย</h1>

  <form *ngIf="!isViewOnly" [formGroup]="researchForm">
    <div class="form-group row">
      <label for="name" class="col-2 col-form-label">ชื่อวิจัย<lifedi-require></lifedi-require></label>
      <div class="col-10">
        <input type="text" class="form-control" id="name" formControlName="name" autocomplete="off">
      </div>
    </div>
    <div class="form-group row">
      <label for="consent" class="col-2 col-form-label">ข้อความยินยอม<lifedi-require></lifedi-require></label>
      <div class="col-10">
        <angular-editor id="_content" formControlName="consent" placeholder="ใส่ข้อความยินยอม" style="margin: 0 auto;"
          [config]="editorConfigConsent">
        </angular-editor>
      </div>
    </div>
    <div class="form-group row">
      <label for="detail" class="col-2 col-form-label">รายละเอียดวิจัย<lifedi-require></lifedi-require></label>
      <div class="col-10">
        <angular-editor id="_content" formControlName="detail" placeholder="ใส่รายละเอียดวิจัย" style="margin: 0 auto;"
          [config]="editorConfig">
        </angular-editor>
      </div>
    </div>
    <div class="form-group row">
      <label for="date" class="col-2 col-form-label">ระยะเวลาเข้าร่วม<lifedi-require></lifedi-require></label>
      <div *ngIf="researchForm.value.alwaysOpen" class="col-6">
        <input id="date" class="form-control" date-format="dd-MM-yyyy HH:mm:ss" formControlName="date"
          [selectMode]="'range'" [owlDateTimeTrigger]="dtPicker" [owlDateTime]="dtPicker" [rangeSeparator]="'-'"
          dateFormat="dd-MM-yyyy" autocomplete="off" disabled readonly>
        <owl-date-time [pickerType]="'calendar'" #dtPicker disabled readonly></owl-date-time>
      </div>
      <div *ngIf="!researchForm.value.alwaysOpen" class="col-6">
        <input id="date" class="form-control" date-format="dd-MM-yyyy HH:mm:ss" formControlName="date"
          [selectMode]="'range'" [owlDateTimeTrigger]="dtPicker" [owlDateTime]="dtPicker" [rangeSeparator]="'-'"
          dateFormat="dd-MM-yyyy" autocomplete="off">
        <owl-date-time [pickerType]="'calendar'" #dtPicker></owl-date-time>
      </div>
      <div class="col-2 justify-content-center align-self-center col-form-label">
        <section>
          <mat-checkbox id="alwaysOpen" color="primary" formControlName="alwaysOpen"
            (click)="clearValueResearchDate(researchForm)">
            เปิดตลอด
          </mat-checkbox>
        </section>
      </div>
    </div>
    <div class="form-group row">
      <label for="researchImg" class="col-2 col-form-label">รูปปก</label>
      <div class="col-6">
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="researchImg" accept=".png, .jpg, .jpeg"
            (change)="onCoverSelected($event, researchForm)">
          <label *ngIf="!researchImg" class="custom-file-label" for="researchImg">Choose file</label>
          <label *ngIf="researchImg" class="custom-file-label" for="researchImg">{{ researchImg }}</label>
        </div>
      </div>
      <button *ngIf="researchImg" mat-icon-button style="display: inline;" (click)="deleteResearchImg(researchForm)">
        <span class="text-danger">✖</span>
      </button>
    </div>
    <div class="form-group row">
      <label for="researchDocument" class="col-2 col-form-label">เอกสารประกอบงานวิจัย</label>
      <div class="col-6">
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="researchDocument"
            accept=".pdf, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excelapplication/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            (change)="onDocumentSelected($event, researchForm)">
          <label *ngIf="!researchDocument" class="custom-file-label" for="researchDocument">Choose file</label>
          <label *ngIf="researchDocument" class="custom-file-label" for="researchDocument">
            {{ researchDocument}}
          </label>
        </div>
      </div>
      <button *ngIf="researchDocument" mat-icon-button style="display: inline;"
        (click)="deleteResearchDocument(researchForm)">
        <span class="text-danger">✖</span>
      </button>
    </div>
    <div class="form-group row">
      <label for="coin" class="col-2 col-form-label">Token<lifedi-require></lifedi-require></label>
      <div class="col-3">
        <input type="number" class="form-control" formControlName="coin" min="0" id="coin"
          (keyup)="checkMoreThanZero($event)">
      </div>
    </div>
    <div class="form-group row">
      <label for="coin" class="col-2 col-form-label">Token สำหรับคนแชร์<lifedi-require></lifedi-require><br>
        <small class="text-danger">* ผู้แชร์จะได้ token เมื่อผู้เข้าลิงก์ทำวิจัยเสร็จ</small>
      </label>
      <div class="col-3">
        <input type="number" class="form-control" formControlName="coinShare" min="0" id="coin"
          (keyup)="checkMoreThanZero($event)">
      </div>
    </div>



    <div *ngIf="!isViewOnly" class="row mt-4">
      <div class="col-6">
        <h4>แบบสอบถามกลุ่มเป้าหมาย</h4>
        <div *ngFor="let target of targetArray.controls; let i = index;" formArrayName="target">
          <div [formGroupName]="i" class="researhCard mb-3">
            <div class="col-12">
              <div class="row" style="justify-content: right;">
                <button mat-icon-button>
                  <img src="../../../../assets/close.png" style="width: 25px;" (click)="deleteQuestion(i)">
                </button>
              </div>
              <div class="container">
                <div class="row mb-3">
                  <label class="col-3 col-form-label">ประเภทคำถาม<lifedi-require></lifedi-require></label>
                  <div class="col-9">
                    <select class="custom-select form-control" formControlName="type" style="display: inline;"
                      (change)="clearForm(target, 'target')">
                      <option selected disabled hidden>เลือกประเภท</option>
                      <option value="choices">Mulitple Choices</option>
                      <option value="text">Text</option>
                      <option value="checkbox">Checkbox</option>
                    </select>
                  </div>
                </div>

                <div *ngIf="target.value.type.length > 0">
                  <div *ngIf="target?.value.type === 'choices'">
                    <div class="row mb-3">
                      <label class="col-3 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
                      <div class="col-9">
                        <input type="text" class="form-control" id="question" formControlName="question"
                          autocomplete="off" ngDefaultControl>
                      </div>
                    </div>
                    <div *ngFor="let c of target.get('choices')['controls']; let j = index" formArrayName="choices">
                      <div [formGroupName]="j" class="row mb-2">
                        <label class="col-2 col-form-label">C{{ j+1 }}<lifedi-require></lifedi-require></label>
                        <input class="form-control col-9" formControlName="choices_detail" type="text">
                        <button *ngIf="j >= 1" mat-mini-fab class="img col-1"
                          (click)="deleteChoice(target.get('choices'), j)"
                          [style.backgroundImage]="'url(\'../../../../assets/remove.png\')'">
                        </button>
                      </div>
                    </div>
                    <!-- <pre>
                      {{target.value | json}}
                    </pre> -->
                    <button mat-mini-fab class="img col-1 mb-2" (click)="addChoice(target.get('choices'))"
                      [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
                    </button>
                  </div>


                  <div *ngIf="target.value.type === 'text'">
                    <div class="row mb-3">
                      <label class="col-3 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
                      <div class="col-9">
                        <input type="text" class="form-control" id="question" formControlName="question"
                          autocomplete="off" ngDefaultControl>
                      </div>
                    </div>
                    <!-- <pre>
                      {{target.value | json}}
                    </pre> -->
                  </div>

                  <div *ngIf="target.value.type === 'checkbox'">
                    <div class="row mb-3">
                      <label class="col-3 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
                      <div class="col-9">
                        <input type="text" class="form-control" id="question" formControlName="question"
                          autocomplete="off" ngDefaultControl>
                      </div>
                    </div>
                    <div *ngFor="let c of target.get('choices')['controls']; let j = index" formArrayName="choices">
                      <div [formGroupName]="j" class="row mb-2">
                        <label class="col-2 col-form-label">C{{ j+1 }}<lifedi-require></lifedi-require></label>
                        <input class="form-control col-9" formControlName="choices_detail" type="text">
                        <button *ngIf="j >= 1" mat-mini-fab class="img col-1"
                          (click)="deleteChoice(target.get('choices'), j)"
                          [style.backgroundImage]="'url(\'../../../../assets/remove.png\')'">
                        </button>
                      </div>
                    </div>
                    <!-- <pre>
                      {{target.value | json}}
                    </pre> -->
                    <button mat-mini-fab class="img col-1 mb-2" (click)="addChoice(target.get('choices'))"
                      [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <lifedi-btn lable="เพิ่มคำถามกลุ่มเป้าหมาย" class="mt-3 mb-3"
            customStyle="padding: 0 25px; background: #414A6B; color:#FFFFFF" (click)="addTarget()">
          </lifedi-btn>
        </div>
      </div>


      <div class="col-6">
        <h4>แบบทดสอบที่ใช้ในวิจัย</h4>
        <div *ngFor="let measure of measureArray.controls; let i = index;" formArrayName="measures">
          <div [formGroupName]="i" class="researhCard mb-3">
            <div class="col-12">
              <div class="row" style="justify-content: right;">
                <button mat-icon-button>
                  <img src="../../../../assets/close.png" style="width: 25px;" (click)="deleteMeasure(i)">
                </button>
              </div>
              <div class="container">
                <div class="row mb-3">
                  <label class="col-3 col-form-label">Wave {{ i+1 }}<lifedi-require></lifedi-require></label>
                  <div class="col-9">
                    <select *ngIf="i === 0" class="custom-select form-control" formControlName="type"
                      style="display: inline;" (change)="clearForm(measure, 'measures')">
                      <option selected disabled hidden>เลือกประเภท</option>
                      <option value="time">ช่วงเวลา</option>
                      <option value="age">ช่วงอายุ</option>
                    </select>
                    <select *ngIf="i > 0" class="custom-select form-control" formControlName="type"
                      style="display: inline;" disabled>
                      <option selected disabled hidden>เลือกประเภท</option>
                      <option value="time">ช่วงเวลา</option>
                      <option value="age">ช่วงอายุ</option>
                    </select>
                  </div>
                </div>


                <div *ngIf="measure.value.type === 'time'">
                  <div class="row mb-3">
                    <label class="col-3 col-form-label">ช่วงเวลา<lifedi-require></lifedi-require></label>
                    <div class="col-9">
                      <input id="moment" class="form-control" date-format="dd-MM-yyyy HH:mm:ss" formControlName="moment"
                        [selectMode]="'range'" [owlDateTimeTrigger]="dtPicker" [owlDateTime]="dtPicker"
                        [rangeSeparator]="'-'" dateFormat="dd-MM-yyyy" autocomplete="off"
                        (dateTimeChange)="setDate($event, measure)">
                      <owl-date-time [pickerType]="'calendar'" #dtPicker></owl-date-time>
                    </div>
                  </div>
                  <div *ngFor="let m of measure.get('measures')['controls']; let j = index" formArrayName="measures">
                    <div [formGroupName]="j" class="row mb-2">
                      <label class="col-3 col-form-label">แบบทดสอบ {{ j+1 }}<lifedi-require></lifedi-require></label>
                      <select class="custom-select form-control col-8" formControlName="measure_id"
                        (change)="setMeasure(measure.get('measures'), j, m)">
                        <option *ngFor="let item of allActiveMeasure" [ngValue]="item.MEASURE_ID">
                          {{item.MEASURE_NAME}}
                        </option>
                      </select>
                      <button *ngIf="j >= 1" mat-mini-fab class="img col-1"
                        (click)="deleteSubMeasure(measure.get('measures'), j)"
                        [style.backgroundImage]="'url(\'../../../../assets/remove.png\')'">
                      </button>
                    </div>
                  </div>
                  <!-- <pre>
                    {{measure.value | json}}
                  </pre> -->
                  <button mat-mini-fab class="img col-1 mb-2" (click)="addSubMeasure(measure.get('measures'))"
                    [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
                  </button>
                </div>


                <div *ngIf="measure.value.type === 'age'">
                  <div class="row mb-2">
                    <label class="col-3 col-form-label">ช่วงอายุ<lifedi-require></lifedi-require></label>
                    <input type="number" class="form-control col-3" formControlName="start_year" max="100" min="1"
                      autocomplete="off" (keyup)="checkYear($event, measure, 'start_year')" (change)="setAge(measure)"
                      ngDefaultControl>
                    <label class="col-1 col-form-label">ปี</label>
                    <input type="number" class="form-control col-3" formControlName="start_month" max="11" min="0"
                      autocomplete="off" (keyup)="checkMonth($event, measure, 'start_month')" (change)="setAge(measure)"
                      ngDefaultControl>
                    <label class="col-1 col-form-label">เดือน</label>
                  </div>

                  <div class="row mb-2">
                    <label class="col-3 col-form-label">ถึงอายุ<lifedi-require></lifedi-require></label>
                    <input type="number" class="form-control col-3" formControlName="end_year" max="100" min="1"
                      autocomplete="off" (keyup)="checkYear($event, measure, 'end_year')" (change)="setAge(measure)"
                      ngDefaultControl>
                    <label class="col-1 col-form-label">ปี</label>
                    <input type="number" class="form-control col-3" formControlName="end_month" max="11" min="0"
                      autocomplete="off" (keyup)="checkMonth($event, measure, 'end_month')" (change)="setAge(measure)"
                      ngDefaultControl>
                    <label class="col-1 col-form-label">เดือน</label>
                  </div>
                  <div class="row mb-2">
                    <small *ngIf="measure.value.from_age >= measure.value.to_age" class="text-danger offset-3">
                      * ถึงอายุต้องมากกว่าช่วงอายุ
                    </small>
                  </div>

                  <div *ngFor="let m of measure.get('measures')['controls']; let j = index" formArrayName="measures">
                    <div [formGroupName]="j" class="row mb-2">
                      <label class="col-3 col-form-label">แบบทดสอบ {{ j+1 }}<lifedi-require></lifedi-require></label>
                      <select class="custom-select form-control col-8" formControlName="measure_id"
                        (change)="setMeasure(measure.get('measures'), j, m)">
                        <option *ngFor="let item of allActiveMeasure" [ngValue]="item.MEASURE_ID">
                          {{item.MEASURE_NAME}}
                        </option>
                      </select>
                      <button *ngIf="j >= 1" mat-mini-fab class="img col-1"
                        (click)="deleteSubMeasure(measure.get('measures'), j)"
                        [style.backgroundImage]="'url(\'../../../../assets/remove.png\')'">
                      </button>
                    </div>
                  </div>
                  <!-- <pre>
                    {{measure.value | json}}
                  </pre> -->
                  <button mat-mini-fab class="img col-1 mb-2" (click)="addSubMeasure(measure.get('measures'))"
                    [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <lifedi-btn lable="เพิ่ม Wave" class="mt-3 mb-3"
            customStyle="padding: 0 25px; background: #414A6B; color:#FFFFFF" (click)="addMeasures()">
          </lifedi-btn>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <lifedi-btn
        *ngIf="researchForm.valid && researchForm.value.target.length >= 1 && researchForm.value.measures.length >= 1"
        lable="บันทึก" class="mx-2 my-3" customStyle="padding: 0 25px; background: #005C3D; color:#FFFFFF"
        (click)="editResearch(researchForm.value)">
      </lifedi-btn>
      <lifedi-btn
        *ngIf="!researchForm.valid || researchForm.value.target.length === 0 || researchForm.value.measures.length === 0"
        lable="บันทึก" class="mx-2 my-3" customStyle="padding: 0 25px; color:#FFFFFF" disabled="true">
      </lifedi-btn>
      <lifedi-btn *ngIf="!isViewOnly" (click)="edit()" lable="ย้อนกลับ" class="mx-2 my-3"
        customStyle="padding: 0 25px; color:#FFFFFF; background: lightgray;">
      </lifedi-btn>
    </div>
  </form>










  <form *ngIf="isViewOnly" [formGroup]="researchForm">
    <div class="form-group row">
      <label for="name" class="col-2 col-form-label">ชื่อวิจัย<lifedi-require></lifedi-require></label>
      <div class="col-10">
        <input type="text" class="form-control" id="name" formControlName="name" autocomplete="off" disabled>
      </div>
    </div>
    <div class="form-group row">
      <label for="consent" class="col-2 col-form-label">ข้อความยินยอม<lifedi-require></lifedi-require></label>
      <div class="col-10">
        <angular-editor id="_content" formControlName="consent" placeholder="ใส่ข้อความยินยอม" style="margin: 0 auto;"
          [config]="editorConfigConsentDisable">
        </angular-editor>
      </div>
    </div>
    <div class="form-group row">
      <label for="detail" class="col-2 col-form-label">รายละเอียดวิจัย<lifedi-require></lifedi-require></label>
      <div class="col-10">
        <angular-editor id="_content" formControlName="detail" placeholder="ใส่รายละเอียดวิจัย" style="margin: 0 auto;"
          [config]="editorConfigDisable">
        </angular-editor>
      </div>
    </div>
    <div class="form-group row">
      <label for="date" class="col-2 col-form-label">ระยะเวลาเข้าร่วม<lifedi-require></lifedi-require></label>
      <div class="col-6">
        <input id="date" class="form-control" date-format="dd-MM-yyyy HH:mm:ss" formControlName="date"
          [selectMode]="'range'" [owlDateTimeTrigger]="dtPicker" [owlDateTime]="dtPicker" [rangeSeparator]="'-'"
          dateFormat="dd-MM-yyyy" autocomplete="off" disabled readonly>
        <owl-date-time [pickerType]="'calendar'" #dtPicker disabled readonly></owl-date-time>
      </div>
      <div class="col-2 justify-content-center align-self-center col-form-label">
        <section>
          <mat-checkbox id="alwaysOpen" color="primary" formControlName="alwaysOpen" disabled>
            เปิดตลอด
          </mat-checkbox>
        </section>
      </div>
    </div>
    <div class="form-group row">
      <label for="researchImg" class="col-2 col-form-label">รูปปก</label>
      <div class="col-6">
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="researchImg" accept=".png, .jpg, .jpeg" disabled>
          <label *ngIf="!researchImg" class="custom-file-label" for="researchImg">Choose file</label>
          <label *ngIf="researchImg" class="custom-file-label" for="researchImg">{{ researchImg }}</label>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="researchDocument" class="col-2 col-form-label">เอกสารประกอบงานวิจัย</label>
      <div class="col-6">
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="researchDocument"
            accept=".pdf, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excelapplication/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            disabled>
          <label *ngIf="!researchDocument" class="custom-file-label" for="researchDocument">Choose file</label>
          <label *ngIf="researchDocument" class="custom-file-label" for="researchDocument">
            {{ researchDocument}}
          </label>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="coin" class="col-2 col-form-label">Token<lifedi-require></lifedi-require></label>
      <div class="col-3">
        <input type="number" class="form-control" formControlName="coin" min="0" id="coin" disabled>
      </div>
    </div>
    <div class="form-group row">
      <label for="coin" class="col-2 col-form-label">Token สำหรับคนแชร์<lifedi-require></lifedi-require><br>
        <small class="text-danger">* ผู้แชร์จะได้ token เมื่อผู้เข้าลิงก์ทำวิจัยเสร็จ</small>
      </label>
      <div class="col-3">
        <input type="number" class="form-control" formControlName="coinShare" min="0" id="coin" disabled>
      </div>
    </div>


    <div class="row mt-4">
      <div class="col-6">
        <h4>แบบสอบถามกลุ่มเป้าหมาย</h4>
        <div *ngFor="let target of targetArray.controls; let i = index;" formArrayName="target">
          <div [formGroupName]="i" class="researhCard mb-3">
            <div class="col-12 my-3">
              <div class="container">
                <div class="row mb-3">
                  <label class="col-3 col-form-label">ประเภทคำถาม<lifedi-require></lifedi-require></label>
                  <div class="col-9">
                    <select class="custom-select form-control" formControlName="type" style="display: inline;" disabled>
                      <option selected disabled hidden>เลือกประเภท</option>
                      <option value="choices">Mulitple Choices</option>
                      <option value="text">Text</option>
                      <option value="checkbox">Checkbox</option>
                    </select>
                  </div>
                </div>

                <div *ngIf="target.value.type.length > 0">
                  <div *ngIf="target?.value.type === 'choices'">
                    <div class="row mb-3">
                      <label class="col-3 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
                      <div class="col-9">
                        <input type="text" class="form-control" id="question" formControlName="question"
                          autocomplete="off" ngDefaultControl disabled>
                      </div>
                    </div>
                    <div *ngFor="let c of target.get('choices')['controls']; let j = index" formArrayName="choices">
                      <div [formGroupName]="j" class="row mb-2">
                        <label class="col-2 col-form-label">C{{ j+1 }}<lifedi-require></lifedi-require></label>
                        <input class="form-control col-9" formControlName="choices_detail" type="text" disabled>
                      </div>
                    </div>
                  </div>


                  <div *ngIf="target.value.type === 'text'">
                    <div class="row mb-3">
                      <label class="col-3 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
                      <div class="col-9">
                        <input type="text" class="form-control" id="question" formControlName="question"
                          autocomplete="off" ngDefaultControl disabled>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="target.value.type === 'checkbox'">
                    <div class="row mb-3">
                      <label class="col-3 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
                      <div class="col-9">
                        <input type="text" class="form-control" id="question" formControlName="question"
                          autocomplete="off" ngDefaultControl disabled>
                      </div>
                    </div>
                    <div *ngFor="let c of target.get('choices')['controls']; let j = index" formArrayName="choices">
                      <div [formGroupName]="j" class="row mb-2">
                        <label class="col-2 col-form-label">C{{ j+1 }}<lifedi-require></lifedi-require></label>
                        <input class="form-control col-9" formControlName="choices_detail" type="text" disabled>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="col-6">
        <h4>แบบทดสอบที่ใช้ในวิจัย</h4>
        <div *ngFor="let measure of measureArray.controls; let i = index;" formArrayName="measures">
          <div [formGroupName]="i" class="researhCard mb-3">
            <div class="col-12 my-3">
              <div class="container">
                <div class="row mb-3">
                  <label class="col-3 col-form-label">Wave {{ i+1 }}<lifedi-require></lifedi-require></label>
                  <div class="col-9">
                    <select class="custom-select form-control" formControlName="type" style="display: inline;" disabled>
                      <option selected disabled hidden>เลือกประเภท</option>
                      <option value="time">ช่วงเวลา</option>
                      <option value="age">ช่วงอายุ</option>
                    </select>
                  </div>
                </div>


                <div *ngIf="measure.value.type === 'time'">
                  <div class="row mb-3">
                    <label class="col-3 col-form-label">ช่วงเวลา<lifedi-require></lifedi-require></label>
                    <div class="col-9">
                      <input id="moment" class="form-control" date-format="dd-MM-yyyy HH:mm:ss" formControlName="moment"
                        [selectMode]="'range'" [owlDateTimeTrigger]="dtPicker" [owlDateTime]="dtPicker"
                        [rangeSeparator]="'-'" dateFormat="dd-MM-yyyy" autocomplete="off" disabled readonly
                        (dateTimeChange)="setDate($event, measure)">
                      <owl-date-time [pickerType]="'calendar'" #dtPicker disabled readonly></owl-date-time>
                    </div>
                  </div>
                  <div *ngFor="let m of measure.get('measures')['controls']; let j = index" formArrayName="measures">
                    <div [formGroupName]="j" class="row mb-2">
                      <label class="col-3 col-form-label">แบบทดสอบ {{ j+1 }}<lifedi-require></lifedi-require></label>
                      <select class="custom-select form-control col-8" formControlName="measure_id" disabled
                        (change)="setMeasure(measure.get('measures'), j, m)">
                        <option *ngFor="let item of allActiveMeasure" [ngValue]="item.MEASURE_ID">
                          {{item.MEASURE_NAME}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>


                <div *ngIf="measure.value.type === 'age'">
                  <div class="row mb-2">
                    <label class="col-3 col-form-label">ช่วงอายุ<lifedi-require></lifedi-require></label>
                    <input type="number" class="form-control col-3" formControlName="start_year" max="100" min="1"
                      autocomplete="off" (keyup)="checkYear($event, measure, 'start_year')" (change)="setAge(measure)"
                      ngDefaultControl disabled>
                    <label class="col-1 col-form-label">ปี</label>
                    <input type="number" class="form-control col-3" formControlName="start_month" max="11" min="0"
                      autocomplete="off" (keyup)="checkMonth($event, measure, 'start_month')" (change)="setAge(measure)"
                      ngDefaultControl disabled>
                    <label class="col-1 col-form-label">เดือน</label>
                  </div>

                  <div class="row mb-2">
                    <label class="col-3 col-form-label">ถึงอายุ<lifedi-require></lifedi-require></label>
                    <input type="number" class="form-control col-3" formControlName="end_year" max="100" min="1"
                      autocomplete="off" (keyup)="checkYear($event, measure, 'end_year')" (change)="setAge(measure)"
                      ngDefaultControl disabled>
                    <label class="col-1 col-form-label">ปี</label>
                    <input type="number" class="form-control col-3" formControlName="end_month" max="11" min="0"
                      autocomplete="off" (keyup)="checkMonth($event, measure, 'end_month')" (change)="setAge(measure)"
                      ngDefaultControl disabled>
                    <label class="col-1 col-form-label">เดือน</label>
                  </div>
                  <div class="row mb-2">
                    <small *ngIf="measure.value.from_age >= measure.value.to_age" class="text-danger offset-3">
                      * ถึงอายุต้องมากกว่าช่วงอายุ
                    </small>
                  </div>

                  <div *ngFor="let m of measure.get('measures')['controls']; let j = index" formArrayName="measures">
                    <div [formGroupName]="j" class="row mb-2">
                      <label class="col-3 col-form-label">แบบทดสอบ {{ j+1 }}<lifedi-require></lifedi-require></label>
                      <select class="custom-select form-control col-8" formControlName="measure_id" disabled
                        (change)="setMeasure(measure.get('measures'), j, m)">
                        <option *ngFor="let item of allActiveMeasure" [ngValue]="item.MEASURE_ID">
                          {{item.MEASURE_NAME}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
